import request from '@/api/request'

const basePath = '/me'

export function fetchMe () {
  return request({
    url: basePath,
    method: 'get'
  })
}

export function fetchMePerm () {
  return request({
    url: basePath + '/perm',
    method: 'get'
  })
}

export function revokeMetabaseToken () {
  return request({
    url: basePath + '/metabase_token',
    method: 'put'
  })
}
